// Раскладка «кирпичиками» в две колонки без пустот: каждая карточка встаёт в более короткую колонку,
// а последняя карточка короткой колонки вытягивается до низа длинной — обе колонки кончаются вровень.
// Пока скрипт не отработал (и на узких экранах), действует обычная CSS-раскладка контейнера.
import { useCallback, useRef } from 'react';

const GAP = 8;

export function layoutMasonry(box: HTMLElement, wide: boolean): void {
  const items = [...box.children].filter((c): c is HTMLElement => c instanceof HTMLElement);
  for (const el of items) { el.style.gridColumn = ''; el.style.gridRow = ''; el.style.minHeight = ''; }
  box.style.marginBottom = '';
  if (!wide) { delete box.dataset.masonry; return; }
  box.dataset.masonry = '';
  const bottoms = [0, 0];
  const last: (HTMLElement | null)[] = [null, null];
  const placed = items.map((el) => {
    const h = el.offsetHeight;
    if (!h) return null;
    const col = bottoms[0] <= bottoms[1] ? 0 : 1;
    const top = bottoms[col];
    bottoms[col] += h + GAP;
    last[col] = el;
    return { el, col, top, h };
  });
  const max = Math.max(bottoms[0], bottoms[1]);
  for (const p of placed) {
    if (!p) continue;
    const h = p.el === last[p.col] ? max - GAP - p.top : p.h;
    if (h > p.h) p.el.style.minHeight = `${h}px`;
    p.el.style.gridColumn = String(p.col + 1);
    p.el.style.gridRow = `${p.top + 1} / span ${h + GAP}`;
  }
  // Сетка кончается зазором под последней карточкой — компенсируем его
  if (max) box.style.marginBottom = `-${GAP}px`;
}

/** Ref-колбэк для контейнера; раскладка обновляется при изменении размеров и состава карточек. */
export function useMasonry(minWidth = 961): (box: HTMLElement | null) => void {
  const stop = useRef<(() => void) | null>(null);
  return useCallback((box: HTMLElement | null) => {
    stop.current?.();
    stop.current = null;
    if (!box || typeof ResizeObserver === 'undefined') return;
    const mq = window.matchMedia(`(min-width: ${minWidth}px)`);
    let frame = 0;
    const run = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(() => layoutMasonry(box, mq.matches)); };
    const ro = new ResizeObserver(run);
    const watch = () => { ro.disconnect(); for (const c of box.children) ro.observe(c); run(); };
    const mo = new MutationObserver(watch);
    mo.observe(box, { childList: true });
    mq.addEventListener('change', run);
    watch();
    stop.current = () => { cancelAnimationFrame(frame); ro.disconnect(); mo.disconnect(); mq.removeEventListener('change', run); };
  }, [minWidth]);
}
